// extracted by mini-css-extract-plugin
module.exports = {"text":"style_text__2mA5i","label":"style_label__2Tgvq","error":"style_error__1O7WT","select":"style_select__AnJfA","inputDisabled":"style_inputDisabled__2GP7m"};